<template>
  <div>
    <apexchart width="100%" type="line" :options="options" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
export default {
  name: 'LineChart',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    dataOptions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      options: {
        chart: {
          id: 'vuechart-line'
        },
        xaxis: {
          categories: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
        },
        yaxis: {
          min: 0,
          max: 1000,
          tickAmount: 5
        },
        stroke: {
          curve: 'smooth'
        },
        colors: ['#6266EA'],
      },
      series: [{
        name: 'series-1',
        data: this.dataOptions
      }]
    }
  }
}
</script>